import { Route } from "components/utils";
import { NotFound } from "pages/notFound";
import { EditTradingDocument } from "pages/tradingDocuments/editTradingDocument/EditTradingDocument";
import { SalesInvoiceHistory } from "pages/tradingDocuments/salesInvoicesLIst/history/SalesInvoiceHistory";
import { SalesInvoicesList } from "pages/tradingDocuments/salesInvoicesLIst/SalesInvoicesList";
import { Redirect, RouteComponentProps, Switch } from "react-router-dom";

export const SalesInvoices = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        exact={true}
        path={`${match.path}`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        exact={true}
        path={`${match.path}/list`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        component={SalesInvoiceHistory}
        exact={true}
        path={`${match.path}/:salesInvoiceId/history`}
        title="Milo - historia faktury sprzedażowej"
      />
      <Route
        component={SalesInvoicesList}
        exact={true}
        path={`${match.path}/list/:tab`}
        title="Milo - faktury sprzedażowe"
      />
      <Route
        component={EditTradingDocument}
        exact={true}
        path={`${match.path}/:tradingDocumentId/edit`}
        title="Milo - edytuj fakturę sprzedażową"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
